import { AuthEnums } from "@/enums/Enums";
import i18n from "@/shared/i18n";
import { useMeetActions } from "@/store/selectors/MeetSelectors";
import { UilArrowLeft, UilArrowRight } from "@iconscout/react-unicons";
import { Button, Col, Form, FormProps, Input, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";

type FieldType = {
  displayName: string;
};
const { Title } = Typography;

const GuestLoginModeForm = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm<FieldType>();

  const { setGuestDisplayName, setMeetDetail } = useMeetActions();

  const displayNameValue = Form.useWatch("displayName", form);

  const onFinish: FormProps<FieldType>["onFinish"] = (values) => {
    setGuestDisplayName(values?.displayName);
  };

  return (
    <div className="form-wrapper">
      <Row
        justify={"center"}
        align={"middle"}
        gutter={[16, 16]}
        className="guest-login-wrapper"
      >
        <Col span={24}>
          <Title className="form-title" level={2}>
            {t("joinMeeting.joinAsGuest")}
          </Title>
        </Col>
        <Col span={24}>
          <Form
            name="userDisplayname"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
            form={form}
          >
            <Form.Item<FieldType>
              name="displayName"
              label={t("general.name")}
              rules={[{ required: true, message: t("error.fillName") }]}
              className="p-0 m-0"
            >
              <Input placeholder={t("actions.fillName")} />
            </Form.Item>

            <Form.Item label=" ">
              <Button
                disabled={!displayNameValue?.trim()}
                type="primary"
                htmlType="submit"
                style={{ width: "100%" }}
              >
                {t("joinMeeting.joinMeeting")}
              </Button>
              <Button
                type="link"
                onClick={() =>
                  setMeetDetail({
                    mode: AuthEnums.Select,
                    token: null,
                  })
                }
                icon={
                  i18n.language === "fa-IR" ? (
                    <UilArrowRight />
                  ) : (
                    <UilArrowLeft />
                  )
                }
                className="p-0 my-2"
              >
                {t("actions.backToOptions")}
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default GuestLoginModeForm;
